const desktop = window.innerWidth > 1024
const mobile = window.innerWidth <= 1024

export { desktop, mobile }
